(function () {
  var scriptSrc = document.currentScript && document.currentScript.src ? document.currentScript.src : "";

  function appendFinalNavCss() {
    if (document.getElementById("dpn-reseller-page-nav-final-v19")) return;

    var href = scriptSrc ? scriptSrc.replace(/\.js(\?.*)?$/, ".css$1") : "";

    if (!href) return;

    var link = document.createElement("link");
    link.id = "dpn-reseller-page-nav-final-v19";
    link.rel = "stylesheet";
    link.href = href + (href.indexOf("?") >= 0 ? "&" : "?") + "loaded=last&navfix=20260706v20";
    document.head.appendChild(link);
  }

  function updateHeaderBottom() {
    var header = document.querySelector(".site-header");
    var inner = document.querySelector(".site-header-inner");
    if (!header) return;

    var target = header.classList.contains("is-floating") && inner ? inner : header;
    document.documentElement.style.setProperty(
      "--reseller-header-bottom",
      Math.ceil(target.getBoundingClientRect().bottom) + "px"
    );
  }

  function run() {
    appendFinalNavCss();
    updateHeaderBottom();
    window.addEventListener("scroll", updateHeaderBottom, { passive: true });
    window.addEventListener("resize", updateHeaderBottom, { passive: true });
    window.setTimeout(updateHeaderBottom, 60);
    window.setTimeout(updateHeaderBottom, 240);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
